export default "__VITE_ASSET__DdNwOBVY__"